"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSearchResultsFacets = void 0;
var _fetching = require("@ori/fetching");
var _searchResultsFacets = require("../queries-net/searchResultsFacets");
var _utils = require("../utils");
/* istanbul ignore file @preserve */ /**
 * Fetch function that fetches facets for a given query and facetFiltering keys
 */ const getSearchResultsFacets = async (param)=>{
    let { graphQlNetUrl, headers, query, facetFiltering } = param;
    var _data_application_productSearchPage, _data_application;
    const data = await (0, _fetching.fetchGraphql)({
        query: _searchResultsFacets.searchResultsFacetsQuery,
        url: graphQlNetUrl,
        variables: {
            query,
            facetFiltering
        },
        headers,
        timeout: 10000
    });
    return (0, _utils.mapFacetFilterFromApi)((_data_application = data.application) === null || _data_application === void 0 ? void 0 : (_data_application_productSearchPage = _data_application.productSearchPage) === null || _data_application_productSearchPage === void 0 ? void 0 : _data_application_productSearchPage.products.facets);
};
exports.getSearchResultsFacets = getSearchResultsFacets;
